@if (menuModel.selectedCategoryAnchorNames().length > 1) {
    <div class="menu-anchorbar" woa-responsive
         [ngClass]="{'with-item-images-or-icons': menuModel.showItemImages()() || configurationModel.isWaiterActor()}">
        <div class="menu-anchorbar-scroller" #scroller woa-element-width
             [ngClass]="{'scrolled': scroller.scrollLeft}"
             (scroll)="scrolling$.next()">
            <div class="menu-anchorbar-scroller-content">
                @for (anchorName of menuModel.selectedCategoryAnchorNames(); track anchorName; let i = $index) {
                    <div class="menu-anchorbar-scroller-content-anchor" #anchor>
                        <div class="menu-anchorbar-scroller-content-anchor-name" woa-activatable
                             [ngClass]="{'selected': i === menuModel.selectedAnchorIndex()}"
                             (onActivate)="menuModel.selectAnchor(i, false, $event)">
                            {{ anchorName }}
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
}
